import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "pgp_token";
export const DEVICE_KEY = "pgp_device_id";
export const REMEMBER_DAYS = 30;

// "Ricordami per 30 giorni": il token del dispositivo fidato è salvato in un cookie
// con scadenza 30 giorni (SameSite=Lax, Secure su https). È questo token che consente
// di saltare l'OTP per 30 giorni sullo stesso dispositivo/browser.
export function setDeviceCookie(value, days = REMEMBER_DAYS) {
  const maxAge = Math.round(days * 24 * 60 * 60);
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${DEVICE_KEY}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
}
export function getDeviceCookie() {
  const m = document.cookie.match(new RegExp("(?:^|; )" + DEVICE_KEY + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : "";
}
export function clearDeviceCookie() {
  document.cookie = `${DEVICE_KEY}=; Max-Age=0; Path=/; SameSite=Lax`;
}

const api = axios.create({ baseURL: API });

export const IMPEXP_TENANT_KEY = "pgp_impexp_tenant";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const impT = sessionStorage.getItem(IMPEXP_TENANT_KEY);
  if (impT && String(config.url || "").includes("/studio/impexp")) config.headers["X-Impexp-Tenant"] = impT;
  return config;
});

// Sessione singola: se il token è stato invalidato da un altro dispositivo,
// il backend risponde 401 con detail "session_superseded" -> disconnetti qui.
export const SA_TOKEN_KEY = "pgp_sa_token";

// Fine sessione di assistenza: ripristina la sessione superadmin salvata.
export function restoreSuperadmin() {
  const sa = localStorage.getItem(SA_TOKEN_KEY);
  if (!sa) return false;
  localStorage.setItem(TOKEN_KEY, sa);
  localStorage.removeItem(SA_TOKEN_KEY);
  window.location.href = "/admin/studi";
  return true;
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && err.response?.data?.detail === "Sessione di assistenza terminata") {
      restoreSuperadmin();
    }
    if (err.response?.status === 401 && err.response?.data?.detail === "session_superseded") {
      if (localStorage.getItem(TOKEN_KEY)) {
        localStorage.removeItem(TOKEN_KEY);
        if (!window.location.pathname.startsWith("/login")) {
          window.location.href = "/login?superseded=1";
        }
      }
    }
    if (err.response?.status === 403 && err.response?.data?.detail === "Demo scaduta") {
      if (localStorage.getItem(TOKEN_KEY)) {
        localStorage.removeItem(TOKEN_KEY);
        if (!window.location.pathname.startsWith("/login")) {
          window.location.href = "/login?demo_scaduta=1";
        }
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
